<template>
  <div id="landing">
    <Navbar></Navbar>
    <header>
      <div class="max">
        <div id="left">
          <h1>
            There's a better way to
            <br />invoice your clients.
          </h1>
          <p>
            TrakYak makes it super simple to create,
            <br />send, and track invoices.
          </p>
          <input type="email" placeholder="Email" />
          <button>Join Beta</button>
        </div>
        <div id="right">
          <div id="image-container">
            <div>
              <img src="@/assets/MInvoice.svg" alt="Invoice Illustrations" />
            </div>
            <div>
              <img src="@/assets/SInvoice.svg" alt="Invoice Illustrations" />
            </div>
            <div>
              <img src="@/assets/LInvoice.svg" alt="Invoice Illustrations" />
            </div>
          </div>
        </div>
      </div>
    </header>
    <div id="features">
      <h1>Here's Why You Should Use TrakYak</h1>
      <div class="card-container">
        <div class="card">
          <img src="@/assets/create.svg" alt />
          <h2>Invoice Builder</h2>
          <p>Rapidly create and edit invoices in our simple to use invoice builder and client presets.</p>
        </div>
        <div class="card">
          <img src="@/assets/send.svg" alt />
          <h2>Send And Receive</h2>
          <p>Easily send invoices to your clients and receive payment with our payment providers</p>
        </div>
        <div class="card">
          <img src="@/assets/track.svg" alt />
          <h2>Track</h2>
          <p>Precisely track your sent and received invoices, time spent on projects, and clients</p>
        </div>
      </div>
    </div>
    <div id="payments">
      <div class="max">
        <h1>Accept Payments With</h1>
        <div class="images row">
          <img src="../assets/square.png" alt />
          <img src="../assets/stripe.png" alt />
          <img src="../assets/paypal.png" alt />
        </div>
      </div>
    </div>
    <div id="pricing">
      <h1>Simple Pricing</h1>
      <div class="max row">
        <div class="card">
          <div class="header">
            <h2>Lite</h2>
            <p class="price">
              $7.99
              <span>/mo</span>
            </p>
          </div>
          <div class="benefits">
            <p>5 Customers</p>
            <p>Simple Invoices</p>
            <p>Connect Stripe & Paypal</p>
            <p>Time Tracking</p>
          </div>
          <button disabled>Get Started</button>
        </div>
        <div class="card" id="popular">
          <div id="popular-text">
            <h2>Most Popular</h2>
          </div>
          <div class="header">
            <h2>Plus</h2>
            <p class="price">
              $19.99
              <span>/mo</span>
            </p>
          </div>
          <div class="benefits">
            <p>30 Customers</p>
            <p>Simple Invoices</p>
            <p>Connect Stripe & Paypal</p>
            <p>Time Tracking</p>
          </div>
          <button disabled>Get Started</button>
        </div>
        <div class="card">
          <div class="header">
            <h2>Pro</h2>
            <p class="price">
              $39.99
              <span>/mo</span>
            </p>
          </div>
          <div class="benefits">
            <p>Unlimited Customers</p>
            <p>Custom Invoice Templates</p>
            <p>Connect Stripe & Paypal</p>
            <p>Time Tracking</p>
          </div>
          <button disabled>Get Started</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "../components/Navbar";

export default {
  name: "Landing",
  data() {
    return {};
  },
  methods: {},
  components: {
    Navbar
  }
};
</script>

<style lang="scss" scoped>
#landing {
  overflow-x: hidden;
}

header {
  color: #f7f9fb;
  background: #0cce6b;
  height: 100vh;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .max {
    padding-top: 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 1198px;
    margin: auto;

    #left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;

      input {
        border: solid 2px #2b303a;
        border-radius: 3px;
        font-size: 1.4rem;
        margin-top: 15px;
        width: 350px;
        text-indent: 10px;
        height: 60px;

        &:hover {
          border-color: #2b303a;
        }
      }

      h1 {
        font-size: 3.125rem;
        text-align: left;
        width: 100%;
        margin: 0 0 20px 0;
      }

      p {
        font-size: 1.5rem;
        text-align: left;
        margin: 20px 0 20px 0;
      }

      button {
        width: 200px;
        height: 60px;
        font-size: 1.3rem;
        border: none;
        border-radius: 5px;
        box-shadow: 0px 4px 15px rgba($color: #000000, $alpha: 0.25);
        font-family: Inter;
        font-weight: 600;
        margin: 20px 0 0 0;
      }
    }

    #right {
      display: flex;
      justify-content: center;
      align-items: center;

      #image-container {
        height: 550px;
        width: 550px;
        display: flex;
        flex-wrap: wrap;

        div {
          width: 45%;
        }

        div:nth-of-type(1) {
          transform: translate(25%, 10%);
          img {
            animation: floating 5.5s infinite ease-in-out;
          }
        }

        div:nth-of-type(2) {
          transform: translateX(25%) rotate(25deg);
          img {
            animation: floating 6s infinite ease-in-out;
          }
        }

        div:nth-of-type(3) {
          width: 100%;
          transform: translate(25%, -10%);
          img {
            animation: floating 5s infinite ease-in-out;
          }
        }
      }
    }
  }
}

#payments {
  background: #0cce6b;
  padding: 50px 0 100px 0;

  .max {
    max-width: 1198px;
    margin: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    h1 {
      padding-bottom: 25px;
      color: #f7f9fb;
    }

    .images {
      display: flex;
      justify-content: space-evenly;
      align-items: center;
      width: 100%;

      img {
        height: 80px;
      }
    }
  }
}

#features {
  max-width: 1198px;
  padding: 50px 0;
  margin: 0 auto;

  .card-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .card {
      padding: 0 15px;

      h2 {
        margin-top: 0;
      }

      p {
        padding: 0 15px;
        font-size: 1.2rem;
        height: 100px;
      }

      img {
        height: 200px;
      }
    }
  }
}

#pricing {
  max-width: 1198px;
  margin: auto;

  h1 {
    padding: 50px 0 100px 0;
  }

  .row {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }

  .card {
    //border: solid;
    width: 275px;
    height: 400px;
    border-radius: 3px;
    box-shadow: 0 5px 25px rgba(51, 51, 51, 0.205);

    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;

    .header {
      background: #0cce6b;
      color: #f7f9fb;
      border-top-right-radius: 3px;
      border-top-left-radius: 3px;
      padding: 15px 0 5px 0;
      box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.1);
      h2 {
        margin: 0;
      }
    }

    .price {
      font-size: 3rem;
      padding: 10px 0;
      margin: 0;
      span {
        margin-left: -5%;
        font-size: 1rem;
      }
    }
  }

  button {
    margin: auto auto 25px auto;
    width: 80%;

    padding: 15px 0;
    font-size: 1.25rem;
    font-family: "Inter";
    font-weight: 600;
    border: none;
    background: #0cce6b;
    color: #f7f9fb;
    border-radius: 3px;
  }

  #popular {
    border: #2b303a solid;
    height: 450px;
    transform: translateY(-50px);

    .header {
      background: #0cce6b;
      color: #f7f9fb;
      border-radius: 0;
    }

    #popular-text {
      height: 50px;
      background: #2b303a;
      color: #f7f9fb;
      display: flex;
      justify-content: center;
      align-items: center;

      h2 {
        margin: 0;
      }
    }
  }
}

@keyframes floating {
  from {
    transform: translate(0, 0px) rotate(0deg);
  }
  50% {
    transform: translate(0, 15px) rotate(2deg);
  }
  to {
    transform: translate(0, -0px) rotate(0deg);
  }
}
</style>